import { Link } from "react-router-dom";
import { usePageMeta } from "../lib/seo";
import { PROJECTS } from "../data/projects";
import { Figure } from "../components/site/Figure";

const tileLayout = {
  "napa-residence": { cell: "lg:col-span-8", tier: "feature", aspect: "aspect-[16/9]" },
  "oakland-hills": { cell: "lg:col-span-6", tier: "standard", aspect: "aspect-[4/5]" },
  "berkeley-hills-claremont": { cell: "lg:col-span-5 lg:col-start-8", tier: "standard", aspect: "aspect-[4/5]" },
  "berkeley-industrial": { cell: "lg:col-span-8", tier: "standard", aspect: "aspect-square" },
  "berkeley-modern-loft": { cell: "lg:col-span-5", tier: "standard", aspect: "aspect-[4/5]" },
};

export default function Projects() {
  usePageMeta(
    "Custom Home Projects — Berkeley, Oakland & Napa | Sandquist Construction",
    "Selected projects. Architecture by David S. Wilson, WA Design."
  );

  return (
    <main className="max-w-[1200px] mx-auto px-6 lg:px-8" data-testid="projects-page">
      <div className="pt-16 sm:pt-24 pb-14 max-w-3xl">
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink">Projects</h1>
        <p className="mt-6 text-base sm:text-lg leading-relaxed text-inkmuted max-w-[65ch]" data-testid="projects-intro">
          Selected projects. Architecture by David S. Wilson, WA Design.
        </p>
      </div>

      <div className="border-t border-hairline mb-16 sm:mb-20" data-testid="project-index">
        {PROJECTS.map((p) => (
          <Link
            key={p.slug}
            to={`/projects/${p.slug}`}
            data-testid={`project-index-${p.slug}`}
            className="group flex items-baseline justify-between gap-6 border-b border-hairline py-5"
          >
            <span className="font-label sc text-sm tracking-[0.16em] text-ink group-hover:text-plaster transition-colors duration-200">{p.name}</span>
            <span className="font-label sc text-sm tracking-[0.16em] text-inkmuted">{p.location.split(",")[0]}</span>
          </Link>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-16 pb-16 sm:pb-24">
        {PROJECTS.map((p) => {
          const layout = tileLayout[p.slug];
          return (
            <Link
              key={p.slug}
              to={`/projects/${p.slug}`}
              className={`group block ${layout.cell}`}
              data-testid={`project-tile-${p.slug}`}
            >
              <Figure
                src={p.cover}
                alt={p.coverAlt}
                tier={layout.tier}
                caption={`${p.name} — ${p.location}`}
                imgClassName={`w-full object-cover ${layout.aspect}`}
              />
            </Link>
          );
        })}
      </div>
    </main>
  );
}
